import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, LogIn } from "lucide-react";
import api, { setToken, formatApiError } from "@/lib/api";
import GoogleButton from "@/components/GoogleButton";
import { Field, inputProps } from "@/components/Field";
import { PortalShell } from "@/pages/AdminLogin";

const OnboardingLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      if (data.user.role !== "hire") {
        toast.error("This portal is for new hires. Administrators should use the admin login.");
        return;
      }
      setToken(data.token);
      navigate("/onboarding/portal", { state: { user: data.user } });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PortalShell title="Employee Onboarding Portal" subtitle="Secure access for new team members.">
      <form onSubmit={submit} className="mt-8 grid gap-5" data-testid="onboarding-login-form">
        <Field label="Email" htmlFor="ol-email" required>
          <input id="ol-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@email.com" {...inputProps("onboarding-login-email-input")} />
        </Field>
        <Field label="Password" htmlFor="ol-password" required>
          <input id="ol-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" {...inputProps("onboarding-login-password-input")} />
        </Field>
        <button type="submit" data-testid="onboarding-login-submit" disabled={loading} className="btn-pink w-full disabled:opacity-60">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />}
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
      <div className="my-6 flex items-center gap-4">
        <span className="h-px flex-1 bg-blush-200" />
        <span className="text-xs uppercase tracking-[0.18em] text-charcoal-faint">or</span>
        <span className="h-px flex-1 bg-blush-200" />
      </div>
      <GoogleButton label="Sign in with your invited Google email" />
      <p className="mt-6 text-center text-xs leading-relaxed text-charcoal-faint">
        Received an invitation email? Open your private activation link to set your password first.
      </p>
    </PortalShell>
  );
};

export default OnboardingLogin;
